import cn from 'classnames';
import React from 'react';

const RsButton = ({ classNames, disabled, children, onClick }) =>
  <button
    className={cn('rx-btn rx-btn--small rx-btn--tertiary rx-btn--left',
      { 'els-disabled-state rx-btn--disabled': disabled },
      classNames,
    )}
    onClick={!disabled ? onClick : null}
    tabIndex={disabled ? '-1' : undefined}
  >
    {children}
  </button>;

RsButton.defaultProps = {
  onClick: () => null,
};

const RsButtonLabel = ({ label }) =>
  <span className="rx-btn-text">
    <span className="rx-btn-text-container">{label}</span>
  </span>;

const RsButtonIcon = ({ type }) =>
  <span className="rx-btn-icon">
    <i className={`ss-${type} button-icon`}/>
  </span>;

export class RsButtonIconType {
  static PLUS = 'plus';
  static DELETE = 'delete';
}

export { RsButton, RsButtonLabel, RsButtonIcon };